import { render, staticRenderFns } from "./resend-button.component.vue?vue&type=template&id=ec49f442&scoped=true"
import script from "./resend-button.component.vue?vue&type=script&lang=js"
export * from "./resend-button.component.vue?vue&type=script&lang=js"
import style0 from "./resend-button.component.vue?vue&type=style&index=0&id=ec49f442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec49f442",
  null
  
)

export default component.exports